import { fetchFromOldApi } from '~/services/Http';
export { prefetchEquipmentData } from './prefetchEquipmentData';

export type EquipmentType = {
  fEquipmentAddUrl?: string;
  fEquipmentId?: number;
  fEquipmentCompEqFK: number;
  fEquipmentType: string;
  fEquipmentItem: string;
  fEquipmentInvNumber: string;
  fEquipmentDeliveryDate: string;
  fEquipmentAttachmentId: number;
  fEquipmentAttachmentName: string;
  fEquipmentReturnDate?: string;
  fEquipmentInfo?: string;
  fEquipmentExpirationDate?: string;
};

export type Equipment = {
  code: string;
  name: string;
  description?: string;
};

export type EquipListType = {
  fComEquipmentId: number;
  fComEquipmentInvNumber: string;
  fComEquipmentType: string;
  fComEquipmentAttachmentId: number;
  fComEquipmentAttachmentName: string;
  fComEquipmentItem?: string;
  fComEquipmentExpirationDate?: string;
};
export const getCompanyEquipment = (
  iEmpId: string,
): Promise<EquipmentType[]> => {
  return fetchFromOldApi('/json/employee/' + iEmpId + '/equipment').then((r) =>
    r.json(),
  );
};

export const getEquipNum = (num?: string): Promise<string> => {
  const ifUsed = num ? `?used=${num}` : '';
  return fetchFromOldApi(`/json/employee/equipment/nextnumber${ifUsed}`).then(
    (r) => r.json(),
  );
};

// All equipment
export const getCompanyEquipmentList = (): Promise<EquipListType[]> => {
  return fetchFromOldApi('/json/company/equipment').then((r) => r.json());
};

export const putEquipmentData = async (
  json: FormData | Object,
  iEmpId: number,
  iEqId: number,
  type: string,
) => {
  return await fetchFromOldApi(
    '/form/employee/' + iEmpId + '/equipment/' + iEqId,
    {
      method: 'PUT',
      ...(type === 'json' && {
        headers: { 'Content-Type': 'application/json' },
      }),
      body: type === 'json' ? JSON.stringify(json) : (json as FormData),
    },
  ).then((r) => r.json());
};

export const postEquipmentData = async (
  json: FormData | Object,
  iEmpId: number,
  type: string,
  url: string,
) => {
  return await fetchFromOldApi(`/${type}${url}/employee/${iEmpId}/equipment`, {
    method: 'POST',
    ...(type === 'json' && {
      headers: { 'Content-Type': 'application/json' },
    }),
    body: type === 'json' ? JSON.stringify(json) : (json as FormData),
  }).then((r) => r.json());
};

export const deleteEquipment = async (iEmpId: number, equipmentId: number) => {
  return await fetchFromOldApi(
    `/json/employee/${iEmpId}/equipment/${equipmentId}`,
    {
      method: 'DELETE',
    },
  ).then((r) => r.json());
};

export const putEquipmentList = async (json: Object, eqId: number) => {
  return await fetchFromOldApi('/json/company/equipment/' + eqId, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(json),
  }).then((r) => r.json());
};
